import React from "react";
import Image from "next/image";
import { Br } from "../molecules/Br";
import { Disclosure } from "@headlessui/react";

import { FaMinus, FaPlus } from "react-icons/fa";
// メインコンポーネント
import steps from "/public/onstep/steps.svg";
import stepsSp from "/public/onstep/steps-sp.svg";

const faqs = [
  {
    question: "導入費用は？",
    answer:
      "限られたご予算でも最適なプランをご提案します。まずはお気軽にご相談ください。",
  },
  {
    question: "収益のあげ方は？",
    answer:
      "どのようなサロンを運営されるかにより、収益の上げ方はさまざまです。オンステップでは、多様なコンテンツ配信、商品販売方法を具備しておりますので、収益機会の最大化を実現できます。",
  },
  {
    question: "カスタマイズの自由度は？",
    answer:
      "オンステップは、導入先様ごとにフロントエンドを完全に独立させております。他オンラインサロンサービスのように、サービスロゴやサービス名が表示されることはなく、細部まで自由なデザイン表現が可能です。",
  },
  {
    question: "システムのアーキテクトは？",
    answer:
      "フロントエンドは、ヘッドレス式で各種APIが準備されており、SPA方式に対応しております。基本的にUIは個別にフロント開発する格好となりますが、標準的なUIはNEXT.JSを利用推奨しております。",
  },
  {
    question: "インフラの構成イメージは？",
    answer:
      "インフラについては、AmazonWebService （AWS）を前提に構築されており、AWSが提供する各種サービス（EC2RDS,Lambda， Elemental Mediaconvert,S3, CloudFrontなど）と、インタラクティブに連携しております。",
  },
];

export default function OnstepIntroduction() {
  return (
    <>
      <div className="mx-auto max-w-screen-xl px-8">
        <div className="relative z-10 flex flex-col gap-4 md:max-w-7xl md:gap-6">
          <div className="space-y-4 md:space-y-8">
            <div className="space-y-2">
              <h3 className=" font-bold text-ter fluid-text-[16px,22px]">
                Steps of Introduction
              </h3>
            </div>
            <h2 className=" font-bold text-pri fluid-text-[22px,45px]">
              デザイン確定からリリースまで、
              <Br />
              最短2.5カ月
            </h2>
          </div>
          <div className="space-y-2 font-bold leading-comfort text-txt-light fluid-text-[16px,21px] md:space-y-5 md:leading-loose">
            <div>
              ONSTEPは、お客様のニーズに合わせた最適なプランを提案。共通基盤技術により迅速な導入を実現し、
              <Br pc />
              自由度の高いカスタマイズでお客様独自のブランドイメージを反映できます。
            </div>
          </div>
        </div>
      </div>
      <div className="mx-auto mt-8 w-full pb-8 md:mt-12 md:pb-24 xl:mt-16 xl:w-7xl">
        <div className="hidden aspect-[1216/196] w-full md:block">
          <Image
            src={steps}
            alt="ONSTEPの背景画像"
            quality={80}
            fill
            sizes="100vw"
            className="object-cover"
            priority={false}
          />
        </div>
        <div className="block aspect-[540/400] w-full md:hidden">
          <Image
            src={stepsSp}
            alt="ONSTEPの背景画像"
            quality={80}
            fill
            sizes="100vw"
            className="object-cover"
            priority={false}
          />
        </div>
      </div>
      {/* 導入事例 */}
      <div className="mb-8">
        <h2 className="text-center font-bold text-gray-500">
          ONSTEPのよくある質問
        </h2>
        <div className="bg-white">
          <div className="mx-auto max-w-6xl px-6 py-8 sm:py-12 lg:px-8 lg:py-16">
            <dl className="divide-bdc-default divide-y">
              {faqs.map((faq) => (
                <div
                  key={faq.id}
                  className="py-4 first:pt-0 last:pb-0 md:py-8 lg:grid lg:grid-cols-12 lg:gap-8"
                >
                  <dt className="font-semibold text-pri fluid-text-[14px,16px] lg:col-span-5">
                    {faq.question}
                  </dt>
                  <dd className="mt-2 lg:col-span-7 lg:mt-0">
                    <p className="text-txt-l leading-relaxed fluid-text-[14px,16px] md:leading-comfort">
                      {faq.answer}
                    </p>
                  </dd>
                </div>
              ))}
            </dl>
          </div>
        </div>
      </div>
    </>
  );
}
